import {createSlice} from "@reduxjs/toolkit";

const initState = {
    tokenValue: null
}

const authSlice = createSlice({
    name: "auth",
    initialState: initState,
    reducers: {
        setTokenValue: (state, action) => {
            state.tokenValue = action.payload;
        },
        removeTokenValue: (state) => {
            state.tokenValue = null;
        }
    }
});

export const {setTokenValue, removeTokenValue} = authSlice.actions;
export default authSlice.reducer;